import createParallax from "$comp/parallax/parallax";

let hero = {

    init: () => {

        hero.selector = '.ce_rsce_hero';
        hero.hero = document.querySelectorAll(hero.selector);

        if (hero.hero.length > 0) {
            hero.run();
        }

        return hero;
    },

    run: () => {


        if (document.body.classList.contains('hero-layout-home')) {

            hero.layer_1 = document.querySelector('.ce_rsce_hero video');
            hero.layer_2 = document.querySelector('.ce_rsce_hero__bgmedia__logo-layer');
            hero.layer_3 = document.querySelector('.ce_rsce_hero figure');
            createParallax(hero.layer_2, {speed: -30, axis: 'y', maxTranslate: 300, translateOffset: 100});
            createParallax(hero.layer_3, {speed: -30, axis: 'y', maxTranslate: 150});

            hero.alternateImages(hero.layer_3);
        }

        if (document.body.classList.contains('hero-layout-image')) {
            hero.layer_4 = document.querySelector('.ce_rsce_hero .ce_downloads');
            hero.layer_6 = document.querySelector('.ce_rsce_hero img');
            createParallax(hero.layer_4, {speed: 3, axis: 'y', maxTranslate: 150});
            createParallax(hero.layer_6, {speed: 6, axis: 'y', maxTranslate: 50});
        }

        if (document.body.classList.contains('hero-layout-default') || document.body.classList.contains('hero-layout-default_level3')) {
            hero.layer_5 = document.querySelector('.ce_rsce_hero__layout-default--right img');
            createParallax(hero.layer_5, {speed: -20, axis: 'y', maxTranslate: 150, startAtBreakpoint: 1024});
        }
    },

    alternateImages: (el) => {
        let paths = el.dataset.alternateimages.split(',');
        paths = hero.shuffle(paths);

        let currentIndex = 0;
        let imgElement = el.querySelector('img');
        imgElement.src = paths[currentIndex];
        currentIndex++;

        //preload images
        let images = paths.map(path => {
            let img = new Image();
            img.src = path;
            return img;
        });

        function changeImage() {
            imgElement.classList.add('fade-out'); // Fügen Sie die Ausblendung hinzu
            setTimeout(() => {
                imgElement.src = "";
                imgElement.src = paths[currentIndex];
                imgElement.classList.remove('fade-out');
                currentIndex = (currentIndex + 1) % images.length;
            }, 1200);
        }

        setInterval(changeImage, 8000);
    },

    // Fisher-Yates (aka Knuth) Shuffle
    shuffle: (array) => {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

};

export default hero.init();